import blue from "./candes/blue-candy.png"
import green from "./candes/green-candy.png"
import orange from "./candes/orange-candy.png"
import purple from "./candes/purple-candy.png"
import red from "./candes/red-candy.png"
import yellow from "./candes/yellow-candy.png"

export const candies = [blue, green, orange, purple, red, yellow, blue]   